import ReactFinalForm from 'components/form/ReactFinalForm';
import { IStatusOption } from 'interfaces';
import { IdentityField } from 'components/form/IdentityField';
import { useTranslation } from 'react-i18next';
import { AutocompleteAdapter } from 'components/form/AutocompleteAdapter';

interface ChangeOrderStatusParams {
  onSubmit: any;
  status: IStatusOption[];
}

function ChangeOrderStatusForm(params: ChangeOrderStatusParams) {
  const { t } = useTranslation();

  const { onSubmit, status } = params;

  return (
    <div>
      <ReactFinalForm onSubmit={onSubmit} formId="editOrderStatus" hideControls>
        <div className="gap-5 w-full">
          <IdentityField
            required
            component={AutocompleteAdapter}
            name="status"
            options={status}
            label={t(`entities.order_head.edit-status-label`)}
            optionLabel="display_name"
            optionValue="value"
          />
        </div>
      </ReactFinalForm>
    </div>
  );
}

export default ChangeOrderStatusForm;
